import React from 'react';
import { connect } from 'react-redux';
import PitchEntity from './PitchEntity'
import { getInterval } from './gameJson'
import OvertakeBall from '../Animations/Movements/OvertakeBall'

class Referee extends PitchEntity {

    static propTypes = {
        convertToPitchPosition: React.PropTypes.func.isRequired,
        getKeyPoints: React.PropTypes.func.isRequired
    }

    constructor(props) {
        super(props);

        this.CurrentPosition = this.props.getKeyPoints(true).startPoint; 
        this.scene_movement = false;

        this.Settings = window.PitchSettings;
    }

    initBall(ball = this.ball ) {
        this.ball = ball;
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.Paused != this.props.Paused && this.props.Paused){
            //console.log('cancelPreviousAnimation');
            this.cancelPreviousAnimation();
        }

        if(prevProps.Paused != this.props.Paused && !this.props.Paused){
            //console.log('OvertakeBall');
            this.cancelPreviousAnimation();
            this.OvertakeBall();
        }

        /*
        if(this.props.currentEvent != prevProps.currentEvent) {
            if(this.props.currentEvent < window.Json.game.length) {
                let event = window.Json.game[this.props.currentEvent];
                var time = getInterval(this.props.currentEvent-1);
                if(event.C != null) {
                    this.cancelPreviousAnimation();
                    this.scene_movement = true;
                    PlayerMoveTo(this, this.props.gameSpeed, time, {Top: 350, Left: 100}, { }, this.currentAnimationCancelationToken)
                        .then(()=> this.currentAnimationCancelationToken = {});
                    
                }
                else if(event.E != null) {
                    this.cancelPreviousAnimation();
                    this.scene_movement = true;
                    PlayerMoveTo(this, this.props.gameSpeed, time, {Top: 200, Left: 80}, { }, this.currentAnimationCancelationToken)
                        .then(()=> this.currentAnimationCancelationToken = {});
                }
                else if(event.N != null) {
                    this.cancelPreviousAnimation();
                    this.scene_movement = true;
                    PlayerMoveTo(this, this.props.gameSpeed, time, {Top: 210, Left: 360}, { }, this.currentAnimationCancelationToken)
                        .then(()=> this.currentAnimationCancelationToken = {});
                }
                else if(!this.props.Paused && this.scene_movement == true){
                    console.log('cancel and overtakeBall');
                    this.cancelPreviousAnimation();
                    this.scene_movement = false;
                    this.OvertakeBall();
                }
            }
        }*/
    }

    OvertakeBall() {
        this.CurrentAnimation = new OvertakeBall(this, this.ball, 100);
        return this.CurrentAnimation.Play(this.props.gameSpeed).catch(this.processCancellation);;
    }

    moveToNewPosition(position, time) {
    }

    render() {
        
        if(this.Settings.ShowReferee == false || this.CheckIfOutsidePitch())
            return null;
       
        var position = this.props.convertToPitchPosition(this.CurrentPosition, this.props.home);

        var diff = this.getPositionDiff();
        var top = position.Top - diff;
        var left = position.Left - diff;

        return (<div style={{ top: top + 'px', left: left + 'px', opacity: this.opacity }}  className={this.getContainerClass()}>
                    <div style={{ background: '#000000', color: '#FFFFFF', borderColor: '#FFFFFF' }} className="player_shape">
                    <div className="player_number">R</div>
                    </div>
                </div>)
    }
    
}
function mapStateToProps(state, ownProps) { 
    return {
        Paused: state.paused,
        ...ownProps
    };
}

export default connect(mapStateToProps, null, null, { withRef: true })(Referee)


/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Referee.js
 **/